<template>
  <o-view>
    <o-nav-bar title="Ticket" :has-back-button="true" />
    <o-section> <p>Ticket in KBC app</p> </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'NMBSConfirmation'
}
</script>
